import React from 'react';
import { navigate } from 'hookrouter';
import styled from 'styled-components';
import { DarkModeSwitch } from 'react-toggle-dark-mode';

const StyledNavBar = styled.div`
  display: flex;
  flex-direction: row;
  // Centering
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin: 10px;
  // Dark Mode
  background-color: ${({ theme }) => theme.windowBg};
  box-shadow: 5px 5px 3px ${({ theme }) => theme.shadowColor};
  // Show above tsparticles
  z-index:1;
  pointer-events: auto;

  position: relative;
`;

const Button = styled.button`
  border: none;
  background-color: transparent;
  color: inherit;
  padding: 14px 28px;
  font-family: "Lato";
  font-size: 16px;
  cursor: pointer;
  display: inline-block;

  padding-left: 10px;
  padding-right: 10px;

  &:hover {
    background: ${({ theme }) => theme.hoverColor};
  }
`;

const ThemeToggle = styled(DarkModeSwitch)`
  position: absolute;
  right: 10px;
  // Gets in the way in really narrow screens, disable
  @media only screen and (max-width: 300px) {
    display: none;
  }
`;

const NavBar = ( {toggleTheme, isDarkMode} ) => {

  return (
    <StyledNavBar>
      <Button onClick={()=> navigate('/')}>Home</Button>
      <Button onClick={()=> navigate('/Posts')}>Posts</Button>
      <Button onClick={()=> navigate('/Works')}>Works</Button>
      <Button onClick={()=> navigate('/About')}>About</Button>
      {/* <Button onClick={toggleTheme}>Toggle theme</Button> */}
      <ThemeToggle checked={isDarkMode === 'dark'} moonColor="grey" sunColor="grey" onChange={toggleTheme}/>
    </StyledNavBar>
  )
};

export default NavBar;
